// English strings (source language): account (sign-in, sign-up, import, status card).

const en = {
  login: 'Sign in',
  register: 'Create an account',
  welcomeBack: 'Welcome back',
  yourAccount: 'Your Gruvetto account',
  loginIntro: 'Get your progress back on all your devices.',
  registerIntro: 'Your progress is saved online, and your name appears in leaderboards and online races.',
  riderName: 'Rider name',
  email: 'Email',
  password: 'Password',
  passwordMin: ' (at least 8 characters)',
  createMine: 'Create my account',
  showPassword: 'Show the password',
  hidePassword: 'Hide the password',
  // forgotten password (ADR 0018)
  forgot: 'Forgot your password?',
  forgotTitle: 'Reset your password',
  forgotIntro: 'Enter your email address: we will send you a link to choose a new password.',
  sendLink: 'Send me the link',
  backToLogin: 'Back to sign in',
  forgotSentTitle: 'Check your inbox',
  forgotSent: (email: string, minutes: number) => `If an account exists for ${email}, a link is on its way. It works for ${minutes} minutes; look in the spam folder if nothing comes.`,
  resetTitle: 'Choose a new password',
  resetIntro: 'Your other sessions will be signed out.',
  newPassword: 'New password',
  setPassword: 'Save and sign in',
  resetDone: 'Password changed',
  offline: 'Server unreachable: start the app with the server (launcher) or check your connection.',
  loggedInAs: (name: string) => `Signed in as ${name}`,
  account: 'Account',
  syncing: 'Syncing…',
  offlineQueue: 'Offline: activities will be sent later',
  synced: (when: string) => `✓ Synced ${when}`,
  memberSince: (when: string) => `member since ${when}`,
  sync: 'Sync',
  logout: 'Sign out',
  syncedToast: 'Synced',
  failed: 'Failed',
  logoutAsk: 'Sign out? Your data stays on the server, nothing stays in this browser.',
  logoutPending: (n: number) => `${n} activit${n === 1 ? 'y' : 'ies'} recorded while the server was unreachable ${n === 1 ? 'has' : 'have'} not been sent yet and would be lost. Sign out anyway?`,
  // Google or Strava sign-in, linked accounts
  or: 'or',
  continueWith: (name: string) => `Continue with ${name}`,
  oauthFinishing: (name: string) => `Signing in with ${name}…`,
  oauthStale: 'This sign-in link did not start in this tab: start again from the app.',
  oauthErrors: {
    denied: 'Sign-in cancelled.',
    expired: 'Sign-in expired: please start again.',
    provider: 'The sign-in service is not responding, try again later.',
  },
  // ways to sign in (ADR 0030): the password row, then the linked accounts
  signInTitle: 'Ways to sign in',
  linkedHelp: 'Each of these opens this same account.',
  passwordSet: 'set',
  noPassword: 'none: you sign in with a linked account',
  noPasswordNoEmail: 'none: this account has no email address, so Strava is its only way in',
  addPassword: 'Set a password',
  passwordLinkSent: (email: string, minutes: number) => `A link is on its way to ${email}: open it to choose your password. It works for ${minutes} minutes.`,
  passwordLinkToast: 'Check your inbox',
  changePassword: 'Change the password',
  changePasswordTitle: 'Change your password',
  changePasswordIntro: 'Your other devices will be signed out; this one stays.',
  currentPassword: 'Current password',
  passwordChanged: 'Password changed. Your other devices were signed out.',
  confirmWithPassword: 'Confirm with your password.',
  lastWayIn: 'Your only way in: set a password or link another account before unlinking it.',
  notLinked: 'not linked',
  linked: 'linked',
  link: (name: string) => `Link ${name}`,
  unlink: 'Unlink',
  unlinkAsk: (name: string) =>
    `Unlink ${name}? You will no longer be able to sign in with this account${name === 'Strava' ? ' or send your activities to it' : ''}.`,
  unlinked: (name: string) => `${name} unlinked`,
  linkedToast: (name: string) => `${name} linked to your account`,
  stravaAuto: 'Automatically send my activities to Strava, with a map of the virtual route',
  stravaAutoOn: 'Your next activities will go to Strava',
  stravaAutoOff: 'Automatic upload to Strava turned off',
  stravaNoWrite: 'Strava did not grant permission to upload activities: unlink, then link your account again with that box checked.',
  // Strava brand guidelines: the wording of the official button and of the "Compatible with Strava" mark (alt texts)
  stravaConnect: 'Connect with Strava',
  stravaCompatible: 'Compatible with Strava',
};
export default en;
